var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClipboardList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4379 28L24.3334 37.1046L17.8955 30.6667L21.6667 26.8954L24.3334 29.5621L29.6667 24.2288L33.4379 28Z",
    fill: "#F14F5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 28H45.6667V33.3333H35V28Z",
    fill: "#F14F5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4379 41.3333L24.3334 50.4379L17.8955 44L21.6667 40.2288L24.3334 42.8954L29.6667 37.5621L33.4379 41.3333Z",
    fill: "#F14F5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35 41.3333H45.6667V46.6667H35V41.3333Z",
    fill: "#F14F5C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2288 2.66667H41.4379L45.6667 6.89543V8H56.3334V61.3333H8.33337V8H19V6.89543L23.2288 2.66667ZM19 13.3333H13.6667V56H51V13.3333H45.6667V18.6667H19V13.3333ZM40.3334 9.10457L39.2288 8H25.4379L24.3334 9.10457V13.3333H40.3334V9.10457Z",
    fill: "#F14F5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardList);
export default __webpack_public_path__ + "static/media/clipboardList.fd9b61b990ce62b73ff34f1adda6bf7b.svg";
export { ForwardRef as ReactComponent };